import { PositionCombobox } from '../PositionCombobox'

type Props = {
	newLogin: string
	newFullName: string
	newPosition: string
	newPassword: string
	newBoardstats: boolean
	newManage: boolean
	newSuper: boolean
	positionOptions: string[]
	onNewLogin: (v: string) => void
	onNewFullName: (v: string) => void
	onNewPosition: (v: string) => void
	onNewPassword: (v: string) => void
	onNewBoardstats: (v: boolean) => void
	onNewManage: (v: boolean) => void
	onNewSuper: (v: boolean) => void
	onBackdrop: () => void
	onCancel: () => void
	onSubmit: () => void
}

export function CreateUserModal({
	newLogin,
	newFullName,
	newPosition,
	newPassword,
	newBoardstats,
	newManage,
	newSuper,
	positionOptions,
	onNewLogin,
	onNewFullName,
	onNewPosition,
	onNewPassword,
	onNewBoardstats,
	onNewManage,
	onNewSuper,
	onBackdrop,
	onCancel,
	onSubmit,
}: Props) {
	return (
		<div className="modal-backdrop modal-backdrop-create" onClick={onBackdrop}>
			<div className="modal-card modal-create" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="create-user-title">
				<div className="modal-create-header">
					<h2 id="create-user-title">Создание учётной записи</h2>
				</div>
				<div className="modal-create-body">
					<div className="modal-create-grid">
						<div className="field">
							<label htmlFor="new-user-login">Логин</label>
							<input
								id="new-user-login"
								autoComplete="username"
								placeholder="Логин"
								value={newLogin}
								onChange={(e) => onNewLogin(e.target.value)}
							/>
						</div>
						<div className="field">
							<label htmlFor="new-user-full-name">Имя</label>
							<input
								id="new-user-full-name"
								placeholder="Иван Иванов"
								value={newFullName}
								onChange={(e) => onNewFullName(e.target.value)}
							/>
						</div>
						<div className="field field-span-create">
							<PositionCombobox
								label="Должность"
								value={newPosition}
								onChange={onNewPosition}
								options={positionOptions}
								placeholder="Выберите из списка или введите новую"
							/>
						</div>
						<div className="field">
							<label htmlFor="new-user-password">Пароль</label>
							<input
								id="new-user-password"
								type="password"
								autoComplete="new-password"
								placeholder="Пароль"
								value={newPassword}
								onChange={(e) => onNewPassword(e.target.value)}
							/>
						</div>
					</div>
					<fieldset className="modal-create-checks">
						<legend>Права доступа</legend>
						<label className="check-custom">
							<input type="checkbox" checked={newBoardstats} onChange={(e) => onNewBoardstats(e.target.checked)} />
							<span className="check-box" aria-hidden="true" />
							<span className="check-text">boardstats</span>
						</label>
						<label className="check-custom">
							<input type="checkbox" checked={newManage} onChange={(e) => onNewManage(e.target.checked)} />
							<span className="check-box" aria-hidden="true" />
							<span className="check-text">выдача прав</span>
						</label>
						<label className="check-custom">
							<input type="checkbox" checked={newSuper} onChange={(e) => onNewSuper(e.target.checked)} />
							<span className="check-box" aria-hidden="true" />
							<span className="check-text">супер админ</span>
						</label>
					</fieldset>
				</div>
				<div className="modal-actions modal-create-actions">
					<button type="button" className="secondary-btn" onClick={onCancel}>
						Отмена
					</button>
					<button type="button" className="primary-btn" onClick={() => void onSubmit()}>
						Создать
					</button>
				</div>
			</div>
		</div>
	)
}
